module.exports = __webpack_public_path__ + "static/media/Drinks-vs.-Quality-of-Day-(1).daadc9e6.png";